<template>
  <nav>
    <v-toolbar id="main-toolbar">
      <v-toolbar-side-icon
        class="hidden-md-and-up"
        @click.native="drawer = !drawer"
      ></v-toolbar-side-icon>

      <v-toolbar-title class="mr-4">
        <router-link class="home" to="/" id="site-logo">
          <img src="@/assets/logo-erling.png" v-if="config.OWNER === 'erling'" />
          <img src="@/assets/logo-ragnvald.png" v-else-if="config.OWNER === 'ragnvald'" />
          <div v-else>Ugyldig OWNER</div>
        </router-link>
      </v-toolbar-title>

      <v-toolbar-items class="hidden-sm-and-down">
        <template v-for="item in items">
          <v-btn
            flat
            :to="{ name: item.linkName, exact: item.exact }"
            :key="'big-' + item.linkName"
          >
            <v-icon size="20">{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-btn>
        </template>
      </v-toolbar-items>

      <v-spacer></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-overflow-btn
          v-if="allCustomers.length > 1"
          :items="allCustomers"
          :value="currentCustomer"
          @change="changeCustomer"
          editable
          dense
          hide-details
          flat
        ></v-overflow-btn>

        <v-btn flat @click="logout">
          <v-icon size="20">logout</v-icon>
          Logg ut
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-navigation-drawer temporary absolute v-model="drawer">
      <v-toolbar flat>
        <v-list>
          <v-list-tile>
            <v-list-tile-title class="title">
              {{ config.MINSIDE_DOMAIN }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-toolbar>

      <v-divider></v-divider>

      <v-list>
        <v-list-tile v-if="allCustomers.length > 1">
          <v-overflow-btn
            :items="allCustomers"
            :value="currentCustomer"
            @change="changeCustomer"
            editable
            dense
            segmented
            hide-details
            flat
          ></v-overflow-btn>
        </v-list-tile>

        <v-list-tile
          v-for="item in items"
          :key="'small-' + item.linkName"
          :to="{ name: item.linkName }"
          :exact="item.exact"
        >
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile
          key="small-logout"
          @click.native="logout"
        >
          <v-list-tile-action>
            <v-icon>logout</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>Logg ut</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-snackbar
      v-model="snackbar"
      :timeout="0"
      class="hidden-md-and-up"
      multi-line
    >
      Du kan bytte hvilken kunde du administrerer ved å gå inn i menyen øverst til venstre
      <v-btn color="pink" flat @click="closeSnackbar">Lukk</v-btn>
    </v-snackbar>

    <v-snackbar
      v-model="snackbar"
      :timeout="0"
      class="hidden-sm-and-down"
      top
    >
      Du kan bytte hvilken kunde du administrerer øverst til høyre
      <v-btn color="pink" flat @click="closeSnackbar">Lukk</v-btn>
    </v-snackbar>
  </nav>
</template>

<script>

function customerLabel (customer) {
  return customer['customerNumber'] + ': ' + customer['companyName']
}

export default {
  mounted () {
    this.snackbar = this.allCustomers.length > 1 && this.$store.state.showMultipleUsersSnackbar
  },
  data () {
    return {
      drawer: false,
      snackbar: false
    }
  },
  components: {
  },
  methods: {
    logout () {
      this.$store.dispatch('clear')
      this.$router.push({ name: 'login-or-redirect' })
    },
    changeCustomer (newCustomerLabel, b, c) {
      this.$store.state.customers.forEach(customer => {
        if (customerLabel(customer) === newCustomerLabel) {
          this.$store.dispatch('setCustomer', customer)
          this.$router.go()
        }
      })
    },
    closeSnackbar () {
      this.snackbar = false
      this.$store.dispatch('setShowMultipleUsersSnackbar', false)
    }
  },
  computed: {
    allCustomers () {
      const ret = []
      this.$store.state.customers.forEach(customer => {
        ret.push(customerLabel(customer))
      })
      return ret
    },
    currentCustomer () {
      return customerLabel(this.$store.state.customer)
    },
    items () {
      const perms = this.$store.state.customer ? this.$store.state.customer.perms : {}
      if (perms.root) {
        return [
          { title: 'Mine tjenester', icon: 'build', linkName: 'my-services', exact: false },
          { title: 'Faktura', icon: 'credit_card', linkName: 'invoices', exact: false },
          { title: 'Mine opplysninger', icon: 'person', linkName: 'my-information', exact: false }
        ]
      } else {
        return [
          { title: 'Mine tjenester', icon: 'build', linkName: 'my-services', exact: false }
        ]
      }
    }
  }
}
</script>

<style scoped>
#main-toolbar {
  background: rgba(255, 255, 255, 0.9);
}

#site-logo img {
  max-height: 30px;
}

.v-icon {
  margin-right: 8px;
}
</style>
